<template>
  <div class="create-password-container">
    <div class="header-container">
      <span class="title">{{ $t('hm.title.dashboard') }}</span>
      <Language class="language"/>
    </div>
    <div class="page-body">
      <div class="title">{{ $t('onboarding.common.loginTitle') }}</div>
      <div class="form-container">
        <div class="email-address">
          <span class="label">{{ $t('hm.label.userName') }}</span>
          <el-input class="input" v-model="loginInfo.name" name="name" placeholder=""/>
          <span v-if="showNameTips" class="tips">{{ emailErrorTips }}</span>
        </div>
        <div class="password">
          <span class="label">{{ $t('hm.label.password') }}</span>
          <el-input class="input" v-model="loginInfo.password" name="password" show-password placeholder=""/>
          <span v-if="!loginInfo.password && showPasswordTips" class="tips">{{ $t('common.message.requiredFormField') }}</span>
        </div>
        <div class="agreement-policy">
          <el-checkbox v-model="policy" class="policy-checkbox" ></el-checkbox>
          <div class="policy-container">
            <div class="policy" :class="isEn && 'is-en'">
              <span>{{ $t('login.company.register.candidate.policy.body') }}</span>
              <a class="policy-link" href="/tos/" target="_blank">{{ $t('login.company.register.candidate.policy.link1') }}</a>
              <span>& </span>
              <a class="policy-link" href="/policy/" target="_blank">{{ $t('login.company.register.candidate.policy.link2') }}</a>
            </div>
          </div>
          <span v-if="showPolicyTips" class="tips">{{ policyErrorTips }}</span>
        </div>
        <div class="forget-password">
          <a
            class="forget-password-link"
            @click="handleForgetPassword"
          >{{ $t('hm.label.forgetPassword') }}
          </a>
        </div>
      </div>
    </div>
    <div class="button-container">
      <div class="button forget-password" @click="handleForgetPassword">{{ $t('hm.btn.resend') }}</div>
      <div class="button submit" @click="handelLogin">{{ $t('hm.btn.toHMDashboard') }}</div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Language from '../common/language.vue'
import { emailRegexp } from '@/utils/validator'
import mixin from '../common/mixin'
import { passwordEncrypt } from '@/utils/rsa'

export default {
  mixins: [mixin],
  components: {
    Language
  },
  data () {
    return {
      loginInfo: {
        name: '',
        password: ''
      },
      policy: false,
      bannerUrl: '',
      showNameTips: false,
      showPolicyTips: false,
      showPasswordTips: false,
      languageOptions: [{ id: 'zh', text: '简体中文' }, { id: 'en', text: 'English' }]
    }
  },
  computed: {
    backUrl () {
      return this.$route.query.backUrl
    },
    emailErrorTips () {
      if (this.loginInfo.name && !emailRegexp.test(this.loginInfo.name)) {
        return this.$t('common.message.invalidEmail')
      } else if (this.loginInfo.name) {
        return ''
      } else {
        return this.$t('common.message.requiredFormField')
      }
    },
    policyErrorTips () {
      if (!this.policy) {
        return this.$t('common.message.needLoginAgreePolicy')
      }
      return ''
    }
  },
  async created () {
    this.initData()
  },
  methods: {
    ...mapActions('hm', ['hmLogin', 'setToken']),
    initData () {
      if (this.$route.query.logout) {
        this.setToken()
      }
      if (this.$route.query.email) {
        this.emailAddress = this.$route.query.email
      }
    },
    async handelLogin () {
      if (!this.loginInfo.name || !this.loginInfo.password) {
        this.showNameTips = !this.loginInfo.name
        this.showPasswordTips = !this.loginInfo.password
        return
      }
      if (!this.policy) {
        this.showPolicyTips = !this.policy
        return
      }
      if (!emailRegexp.test(this.loginInfo.name)) {
        this.showNameTips = true
        return
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const params = {
          email_address: this.loginInfo.name,
          password: passwordEncrypt(this.loginInfo.password)
        }
        const resp = await this.hmLogin(params)
        if (resp && resp.token) {
          if (this.backUrl) {
            window.location.href = this.backUrl
          }
          this.$router.push({ name: 'hm-dashboard' })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleForgetPassword () {
      this.$router.push({ name: 'forgetPasswordPage' })
    }
  }
}
</script>
<style lang="scss" scoped>
.create-password-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  background-color: #f7f7f7;

  .header-container {
    min-height: 110px;
    width: 100%;
    background-color: #0b0d1a;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .title {
      color: #FFFFFF;
      font-size: 28px;
      font-weight: 600;
    }

    .hm-info {
      margin-right: 10%;
    }

    .language {
      position: absolute;
      right: 5%;
      top: 25px;
      width: auto;
    }
  }

  .page-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 60%;

    .title {
      padding: 60px;
      font-weight: bolder;
      text-align: center;
      font-size: 24px;
    }

    .form-container {
      background-color: #FFFFFF;
      width: 100%;
      margin-bottom: 30px;

      &> div {
        display: flex;
        align-items: center;
        margin: 0 170px 0 30px;
      }

      .email-address {
        flex: 1;
        margin-top: 70px;
        margin-bottom: 40px;
        position: relative;
      }

      .agreement-policy {
        flex: 1;
        margin-bottom: 70px;
        position: relative;
        .policy-link {
          color: #0096cc;
        }

        .policy-checkbox {
          ::v-deep {
            .el-checkbox__input {
              line-height: 0;
              &.is-checked {
                .el-checkbox__inner {
                  background-color: #fff;
                  border-color: #b2b2b2;
                }
              }

              &.is-focus {
                .el-checkbox__inner {
                  border-color: #b2b2b2;
                }
              }
              .el-checkbox__inner {
                width: 20px;
                height: 20px;
                border-color: #b2b2b2;
                border-radius: 0;

                &:hover {
                  border-color: #b2b2b2;
                }

                &::after {
                  width: 6px;
                  height: 14px;
                  border-width: 3px;
                  border-color: #4d4d4d;
                  top: 0;
                  left: 5px;
                }
              }
            }
          }
        }
      }

      .password {
        flex: 5;
        margin-top: 20px;
        margin-bottom: 40px;
        position: relative;
      }

      .forget-password {
        position: relative;
        .forget-password-link {
          position: absolute;
          right: 15px;
          top: -35px;
          font-size: 14px;
          cursor: pointer;
          color: #0096cc;
          text-decoration: none;
        }

        .forget-password-link:hover{
          color: #405660;
        }
      }

      .label {
        white-space: nowrap;
        font-size: 16px;
        width: 25%;
        text-align: right;
      }

      .policy-checkbox {
        white-space: nowrap;
        font-size: 16px;
        width: 25%;
        text-align: right;
      }

      .policy-container{
        text-align: left;
        margin-left: 30px;
        width: 70%;
        span {
          font-size: 16px;
        }
        a {
          font-size: 16px;
        }
      }

      .input {
        text-align: right;
        margin-left: 30px;
        width: 70%;
      }

      .tips {
        position: absolute;
        left: 25%;
        color: red;
        right: auto;
        top: 45px;
        padding-left: 30px;
        margin: 0;
      }
    }
  }

  ::v-deep .el-input {
    .el-input__inner {
      border: 0;
      background-color: #f7f7f7;
      color: #000000;
    }
  }

  .button-container {
    display: flex;
    width: 60%;
    min-width: 1100px;
    justify-content: space-between;

    .button {
      background-color: rgb(173, 173, 173);
      padding: 10px 20px;
      min-width: 200px;
      color: #FFFFFF;
      font-size: 14px;
      white-space: nowrap;
      text-align: center;
      cursor: pointer;

      &.submit {
        background-color: #0096cc;
      }
    }
  }
}
</style>
